import React from "react";
import DemoPages from "./DemoPages";

function App() {
  return (
      <DemoPages />
  );
}

export default App;
